import type { PropsWithChildren } from 'react';
import type { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import AutoplayPlugin, { type AutoplayOptionsType } from 'embla-carousel-autoplay';
import CarouselPagination from './Pagination';

export type CarouselOptions = EmblaOptionsType & {
  autoplay?: AutoplayOptionsType;
};

export type CarouselProps = PropsWithChildren<{
  className?: string;
  showPagination?: boolean;
  /**
   * An optional boolean that enables or disables the autoplay functionality (default: `false`)
   *
   * @see {@link CarouselOptions.autoplay} for options that control the behavior of the autoplay plugin
   */
  autoplay?: boolean;
  options?: CarouselOptions;
}>;

const Carousel = (props: CarouselProps) => {
  const autoplayOptions = {
    playOnInit: props.autoplay ?? false,
    ...(props.options?.autoplay ?? {}),
  };

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      align: 'center',
      ...(props.options ?? {}),
    },
    [AutoplayPlugin(autoplayOptions), WheelGesturesPlugin()]
  );

  const showPagination = props.showPagination ?? false;

  return (
    <div className="overflow-hidden" ref={emblaRef}>
      <div className={props.className}>{props.children}</div>

      {showPagination && emblaApi && <CarouselPagination carousel={emblaApi} />}
    </div>
  );
};

export default Carousel;
